var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    _vm._g(
      _vm._b(
        { staticClass: "btn btn-sm btn-success" },
        "button",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c("font-awesome-icon", { attrs: { icon: ["far", "plus"], size: "xs" } }),
      _vm._v(" "),
      _vm.label
        ? _c("span", { staticClass: "pl-1" }, [_vm._v(_vm._s(_vm.label))])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }